import React from 'react'

import Close from '../../Assets/Icons/cross.svg';
import RollandGarros from '../../Assets/Images/rollandGarros.jpeg'
import './PlanModal.scss'
import BaseButton from "../BaseButton/BaseButton";

interface PlanModalProps {
    visible: boolean,
    onClose: () => void
}

const PlanModal: React.FC<PlanModalProps> = ({visible, onClose}: PlanModalProps) => {

    if(!visible) {
        return <></>
    }

    return (
        <div className="planModal">
            <div className="planModal__close">
                <img className="planModal__close--img" src={Close} alt="close" onClick={onClose} />
            </div>
            <img className="planModal--img" src={RollandGarros} alt="plan de rolland garros" />
            <div className="planModal--btn">
                <BaseButton onClick={onClose} text="Fermer" type="outline" />
            </div>
        </div>
    )
}

export default PlanModal;
